'use strict';

module.exports = require('@wix/wix-data-webmethod-structures');